import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';

import "./List.scss";

const List = () => {
  let navigate = useNavigate();
  const [applicationData, setApplicationData] = useState(null);
  const [cookies, setCookie, removeCookie] = useCookies(['accept-cookies']);


  useEffect(() => {
    if (!cookies["accept-cookies"]) {
      return () => {};
    }
    fetch('./requestApplications.php', {
      // credentials: "include",
    })
      .then(response => response.json())
      .then(data => {
        setApplicationData(data);
      });
  }, []);


  if (!applicationData) {
    return (
      <div className="list">
        <p>Loading...</p>
      </div>
    );
  }


  const viewApplication = (id) => {
    navigate("/view?id=" + id);
  }

  return (
    <div className="list">
      {Object.keys(applicationData).map((key) => {
        const application = applicationData[key];
        return (
          <div key={application.id} className="list__item">
            <span className="list__id">{application.id}</span>
            <img src={application.steamAvatar} alt="avatar" className="list__avatar" />
            <div className="list__info">
              <div className="list__discord">{application.discordName}</div>
              <div className={`list__status list__status--${application.status}`}>
                {application.status}
              </div>
            </div>
            <div className="list__info">
              <div className="list__date">{application.date}</div>
              <div className="list__reviewer">Sprawdzone przez: {application.checker}</div>
              {application.checker2 != "" ? (
                <div className="list__reviewer">Przyjęty przez: {application.checker2}</div>
              ) : null}
            </div>
            <button className="list__button" onClick={() => viewApplication(application.id)}>Zobacz podanie</button>
          </div>
        );
      })}
    </div>
  );
};

export default List;
